import { sortBy } from 'lodash';

export const sortCurriculum = (curriculums: any) =>
  sortBy(curriculums, o => o.productCurriculum?.name);
